module.exports = __webpack_public_path__ + "img/boleto.1b3e6694.svg";